export class SetupIntent {
  constructor(
    public readonly id: string,
    public readonly secret: string,
    public readonly status: string,
  ) {
  }
}